import React from 'react';
import { Drawer as DrawerNew } from './Drawer';
import { convertOldDrawerProps } from './converter.old';
import type { OldDrawerProps } from './converter.old';

export type DrawerProps = OldDrawerProps;

export const Drawer = React.forwardRef<HTMLDivElement, React.PropsWithChildren<DrawerProps>>((props, ref) => (
  <DrawerNew {...convertOldDrawerProps(props)} ref={ref} />
));
